import {CommentLoading} from '@github-ui/commenting/CommentLoading'
import {VisuallyHidden} from '@primer/react'
import type {Ref} from 'react'

import {TEST_IDS} from '../constants/test-ids'
import {VALUES} from '../constants/values'
import styles from './issue-timeline-loading.module.css'

type IssueTimelineLoadingProps = {
  rowCount?: number
  delayedShow?: boolean
  /** Visually hidden text that tells screen reader users what is loading. */
  label?: string
  ref?: Ref<HTMLDivElement>
}

export const IssueTimelineLoading = ({
  rowCount = VALUES.rowLoadingSkeletonCount,
  delayedShow,
  label,
  ref,
}: IssueTimelineLoadingProps) => {
  return (
    <div ref={ref} className={delayedShow ? styles.delaySkeletonLoad : ''} data-testid={TEST_IDS.issueTimelineLoading}>
      {label && <VisuallyHidden>{label}</VisuallyHidden>}
      {[...Array(rowCount)].map((_, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <div key={index}>
          <CommentLoading />
        </div>
      ))}
    </div>
  )
}
